import Slideshow from '../slideshow/slideshow';
import * as $ from 'jquery';
import App from '../app';
import AppSingleton from '../../services/appSingleton';

export default class Product {

    private upsellSlideshowElement:any;
    private upsellSlideshow:Slideshow;
    private upsellSlideshowAjaxUrl:string;
    private emissionSlideshowElement:any;
    private emissionSlideshow:Slideshow;
    private emissionSlideshowAjaxUrl:string;
    private popupSlideshowElement:any;
    private popupSlideshow:Slideshow;
    private popupSlideshowAjaxUrl:string;
    private intervalID;
    private counter1 = 0;
    private counter2 = 0;
    private app:App;
    private producttabs:any;
    private producttabsli:any;


    constructor() {
        this.app = AppSingleton.getInstance();
        this.initUpsellSlideshow();
        this.initEmissionSlideshow();
        this.producttabsli = $(".producttabs .tab-li");
        this.initTabs();
        var addToCart = document.getElementById("add-product-to-cart");
        if(typeof addToCart !== "undefined" && addToCart !== null) {
            addToCart.addEventListener("click", () => {
                this.waitingPopupOpned();
            }, false);
        }
    }

    /**
     *
     * @param url
     * @param slideshow
     * @param beforeAdd
     * @param afterAdd
     */
    protected loadSlideshowData(url, slideshow:Slideshow = this.upsellSlideshow, beforeAdd:any = null, afterAdd:any = null) {


        $.ajax(url).done((data) => {
            if (typeof data.productsHtml !== 'undefined') {
                if (beforeAdd) beforeAdd(data);

                data.productsHtml.forEach(html => {
                    slideshow.addElement(html);
                });

                if (afterAdd) afterAdd(data);
            }
        });
    }

    /**
     * Initialiaze Upsell slideshow
     */

    initUpsellSlideshow() {

        this.upsellSlideshowElement = $('#upgrade-product-slideshow');
        this.upsellSlideshowAjaxUrl = this.upsellSlideshowElement.data('ajax-url');
        this.upsellSlideshow = new Slideshow(this.upsellSlideshowElement, 4);
        this.loadSlideshowData(this.upsellSlideshowAjaxUrl, this.upsellSlideshow, () => {
            this.upsellSlideshow.emptySlideshow();
        });
    }

    /**
     * Initialiaze popup exclusive & upgrade slideshow
     */

    waitingPopupOpned() {
        this.intervalID = setInterval(()=> {
            this.initpopupSlideshow();
            this.initpopinUpgradeSlideshow();
        }, 1000);
    }

    initpopupSlideshow() {
        this.counter1++;
        if ($('#popup-exclusive-slideshow').length && $('#popup-exclusive-slideshow').children().length > 3) {
            this.popupSlideshowElement = $('#popup-exclusive-slideshow');
            this.popupSlideshowAjaxUrl = this.popupSlideshowElement.data('ajax-url');
            this.popupSlideshow = new Slideshow(this.popupSlideshowElement, 3);

            this.loadSlideshowData(this.popupSlideshowAjaxUrl, this.popupSlideshow, () => {
                this.popupSlideshow.emptySlideshow();
            });
            clearInterval(this.intervalID);
        }
        if (this.counter1 == 10)
            clearInterval(this.intervalID);
    }

    initpopinUpgradeSlideshow() {
        this.counter2++;
        if ($('#upgrade-product-slideshow-popin').length && $('#upgrade-product-slideshow-popin').children().length > 3) {

            this.popupSlideshowElement = $('#upgrade-product-slideshow-popin');
            this.popupSlideshowAjaxUrl = this.popupSlideshowElement.data('ajax-url');
            this.popupSlideshow = new Slideshow(this.popupSlideshowElement, 3);

            this.loadSlideshowData(this.popupSlideshowAjaxUrl, this.popupSlideshow, () => {
                this.popupSlideshow.emptySlideshow();
            });
            clearInterval(this.intervalID);
        }
        if (this.counter2 == 10)
            clearInterval(this.intervalID);

    }


    /**
     * Initialiaze emission slideshow
     */
    initEmissionSlideshow() {

        this.emissionSlideshowElement = $('#emission-slideshow');
        this.emissionSlideshowAjaxUrl = this.emissionSlideshowElement.data('ajax-url');
        this.emissionSlideshow = new Slideshow(this.emissionSlideshowElement, 4);
        this.loadSlideshowData(this.emissionSlideshowAjaxUrl, this.emissionSlideshow, () => {
            this.emissionSlideshow.emptySlideshow();
        });
    }

    /**
     * Initialize Tabs for Mobile
     */
    initTabs() {
        if (this.app.isMobile()) {
            this.producttabsli.each(function () {
                var tabsId = $(this).find("a").attr('href');
                $(this).after($(tabsId));
                if ($(this).hasClass("active-tab")) {
                    setTimeout(function () {
                        $(tabsId).show();
                    }, 1000);
                }


            });
            $(".contents").remove();
            this.producttabsli.on('click', function (e) {
                e.preventDefault();
                var tabsId = $(this).find("a").attr('href');
                if ($(this).hasClass("active-tab")) {
                    $(this).removeClass("active-tab");
                    $(this).find(".fa-angle-right").show();
                    $(this).find(".fa-angle-down").hide();
                    $(tabsId).fadeOut();
                }
                else {
                    $(this).find(".fa-angle-right").hide();
                    $(this).find(".fa-angle-down").show();
                    $(this).addClass("active-tab");
                    $(tabsId).fadeIn();
                }
            });
        }
        /** Show more detail products */
        // Configure/customize these variables.
        let showChar = 1000;  // How many characters are shown by default
        let moretext = "Voir plus de description";

        $('#product-moredetails .description').each(function () {
            let content = $.trim($(this).text());
            let ContentHtml = $(this).html();

            if (content.length > showChar) {
                let htmlContent = $(this).html();
                let contentStart = content.substring(0, showChar);
                contentStart = contentStart.substring(0, contentStart.lastIndexOf(' '));
                let lastThreeChar = contentStart.split(" ").splice(-3);
                let lastThreeCharacter = lastThreeChar[0] + " " + lastThreeChar[1] + " " + lastThreeChar[2];
                let indexStart = htmlContent.indexOf(lastThreeCharacter);
                let i = 0;
                while (indexStart === -1 && i < 10) {
                    lastThreeChar = contentStart.split(" ").splice(-3);
                    lastThreeCharacter = lastThreeChar[0] + " " + lastThreeChar[1] + " " + lastThreeChar[2];
                    contentStart = contentStart.substring(0, contentStart.indexOf(lastThreeCharacter));
                    indexStart = htmlContent.indexOf(lastThreeCharacter);
                    i++;
                }
                htmlContent = htmlContent.substring(0, indexStart) + "<span class='moretext'> ...</span>";
                $(this).html(htmlContent);
                $(this).after('<button class="button jkit-btn-inverse toggle">' + moretext + '</button>');
                $("#product-moredetails .toggle").click(function () {
                    $(this).parent().animate({'opacity': 0}, 400, function () {
                        $(this).html(ContentHtml).animate({'opacity': 1, 'transition': 'all .5s ease-in-out'}, 400);
                    });
                    $(this).hide();
                    $('.moretext').hide();
                });

            }

        });


    }


}